import { useRuntime } from './useRuntime';

type Whitelabel =
  | 'DE_billiger-mietwagen'
  | 'FR_carigami'
  | 'ES_floyt'
  | 'IT_floyt'
  | 'NL_floyt';

// Map locales to Whitelabels
const whitelabels: Record<string, Whitelabel> = {
  'de-DE': 'DE_billiger-mietwagen',
  'fr-FR': 'FR_carigami',
  'es-ES': 'ES_floyt',
  'it-IT': 'IT_floyt',
  'nl-NL': 'NL_floyt',
};

const getWhitelabel = (locale: string = 'de-DE') => whitelabels[locale];

export const useWhitelabel = () => {
  const { locale } = useRuntime();
  const whitelabel = getWhitelabel(locale);
  return { whitelabel };
};
